<template>
    <div>
        <h1>404 Seite nicht gefunden...</h1>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>